import { ServiceProxyMap, createAxiosClient } from '@atlassian/temp-client-utils';
const client = createAxiosClient({ baseURL: '/api/1/report' }, ServiceProxyMap.ANS);
interface Payload {
  userName: string;
  userEmail: string;
  AAID: string;
  userInput: string;
  appName: string;
  errorPageURL: string;
  errorMessage?: string;
  type?: string;
  splunkQueryUrl?: string;
  shouldCreateSupportTicket?: boolean;
  summary?: string;
  feedbackType?: string;
}
export async function reportFeedback(payload: Payload, files?: File[]): Promise<any> {
  const payloadString = JSON.stringify(payload);
  const formData = new FormData();
  formData.append('payload', payloadString);
  if (Array.isArray(files)) {
    for (let i = 0; i < files.length; i++) {
      formData.append('files', files[i]);
    }
  }
  const result = await client.post('/', formData);
  return result.data;
}
